module.exports = __webpack_public_path__ + "img/fig_5.8d7b8ac2.png";